import type { NewContractFormOutput } from "web_myplann/Goals/Forms/newContractFormSchema";
import type { NewContractCreateRequest } from "web_myplann/Goals/Types/NewContractCreateRequest";

export const mapNewContractToCreateRequest = (
	values: NewContractFormOutput,
): NewContractCreateRequest => ({
	name: values.name,
	contractNumber: values.contractNumber,
	producer: values.producer,
	product: values.product,
	manualValue: { value: values.value },
});
